import { Button } from "@pondigitalsolutions/pon-component-library";
import { ButtonBlockProps } from "../types/ButtonBlockTypes";
import { useNavigate } from "react-router-dom";

export default function ButtonBlock({
  blockKey,
  title,
  link,
}: ButtonBlockProps) {
  const navigate = useNavigate();

  if (!title && !link) return null;

  const handleClick = () => {
    // Internal link, use React Router's navigate
    if (link?.linktype === "story") {
      void navigate(`/${link.cached_url}`);
    }
  };

  return (
    <Button
      id={blockKey}
      size="xl"
      variant="primary"
      endIcon="ChevronRight"
      className="my-6"
      onClick={link?.linktype === "story" ? handleClick : undefined}
      renderProp={
        link?.linktype === "url" ? (
          <a
            href={link?.url || link?.cached_url || "#"}
            target={link?.target || "_blank"}
            rel="noopener noreferrer"
          >
            {title}
          </a>
        ) : undefined
      }
    >
      {title}
    </Button>
  );
}
